// URLs públicas do catálogo. O backend devolve `slug`/`url`; o fallback por ID
// continua funcionando porque /curso/:id redireciona para a URL com slug.
export const courseUrl = (curso) => {
  if (!curso) return '/cursos';
  if (curso.url) return curso.url;
  if (curso.slug) return `/cursos/${curso.slug}`;
  return `/curso/${curso.id}`;
};

export const categoryUrl = (categoria) => {
  if (!categoria) return '/cursos';
  return categoria.url || `/cursos/${categoria.slug}`;
};

// Dados que o servidor embutiu no HTML inicial (/cursos/:slug), usados para
// renderizar sem nova requisição nem "flash" de carregamento.
let seoData;

export const getServerData = (matches) => {
  if (seoData === undefined) {
    const element = typeof document !== 'undefined' ? document.getElementById('__SEO_DATA__') : null;
    try {
      seoData = element ? JSON.parse(element.textContent) : null;
    } catch {
      seoData = null;
    }
  }

  return seoData && matches(seoData) ? seoData : null;
};
